// extracted by mini-css-extract-plugin
export default {"withLayout":"Dashboard_withLayout__7gxH7","container":"Dashboard_container__AJMcC"};